import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { createDropdown } from '@ckeditor/ckeditor5-ui/src/dropdown/utils';
import CustomFontFamilyInputFormView from './fontfamilyformview';
import fontFamilyIcon from '../../theme/icons/font-family.svg';
import {DEFAULT_FONT_FAMILY, showFakeVisualSelection, hideFakeVisualSelection, makeSelectionHighlighter} from '../utils';

const VISUAL_SELECTION_MARKER_NAME = 'font-family-ui';

export default class FontFamilyUI extends Plugin {

	static get pluginName() {
		return 'customFontFamilyUI';
	}

	init() {
		const editor = this.editor;

		editor.ui.componentFactory.add( 'customFontFamily', locale => {
			const dropdown = createDropdown( locale );
			const form = new CustomFontFamilyInputFormView( editor.locale );

			const command = editor.commands.get( 'customFontFamily' );

			this._setUpDropdown( dropdown, form, command, editor );
			this._setUpForm( dropdown, form, command );

			makeSelectionHighlighter(editor, VISUAL_SELECTION_MARKER_NAME)

			return dropdown;
		} );
	}

	_setUpDropdown( dropdown, form, command ) {
		const editor = this.editor;
		const t = editor.t;
		const button = dropdown.buttonView;

		dropdown.bind( 'isEnabled' ).to( command );
		dropdown.panelView.children.add( form );

		button.set( {
			label: t( 'Font Family' ),
			icon: fontFamilyIcon,
			tooltip: true
		} );

		button.on( 'open', () => {

			form.fontFamilyInputView.fieldView.value = form.fontFamilyInputView.fieldView.element.value = command.value || DEFAULT_FONT_FAMILY;

			form.fontFamilyInputView.fieldView.select();
			form._updateNameList(form.fontFamilyInputView.fieldView.value);
			form.focus();

		}, { priority: 'low' } );

		dropdown.on( 'submit', () => {

			editor.execute( 'customFontFamily', form.fontFamilyInputView.fieldView.element.value );
			closeUI();

		} );

		this.listenTo( dropdown, 'execute', evt => {
			editor.execute( 'customFontFamily', evt.source.commandParam );
			closeUI()
		} );


		dropdown.on( 'cancel', () => closeUI() );

		// Show the selection color
		dropdown.on('change:isOpen', (evt, name, isVisible) => {
			if( isVisible ) {
				showFakeVisualSelection(editor.model, VISUAL_SELECTION_MARKER_NAME)
			}else{
				hideFakeVisualSelection(editor.model, VISUAL_SELECTION_MARKER_NAME)
			}
		})


		function closeUI() {
			editor.editing.view.focus();
			dropdown.isOpen = false;
		}
	}
	_setUpForm( dropdown, form, command ) {

		form.nameListView.items.delegate('execute').to(dropdown);

	}
}
